import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';
import { CreateClientPayload, UpdateClientPayload, DeleteClientPayload, FetchClientByIdPayload } from './clientTypes';

// Create Client
export const createClient = createAsyncThunk(
  'clients/createClient',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.post('/clients', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create client');
    }
  }
);

// Update Client
export const updateClient = createAsyncThunk(
  'clients/updateClient',
  async ({ clientId, ...data }: UpdateClientPayload & { clientId: number }, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.put(`/clients/${clientId}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update client');
    }
  }
);

// Delete Client
export const deleteClient = createAsyncThunk(
  'clients/deleteClient',
  async ({ clientId }: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.delete(`/clients/${clientId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete client');
    }
  }
);

// Fetch Client by ID
export const fetchClientById = createAsyncThunk(
  'clients/fetchClientById',
  async ({ clientId }: FetchClientByIdPayload, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/clients/${clientId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch client');
    }
  }
);

// Fetch All Clients
export const fetchAllClients = createAsyncThunk(
  'clients/fetchAllClients',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/clients');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch clients');
    }
  }
);
// Fetch Clients Summary
export const fetchClientSummary = createAsyncThunk(
  'clients/getClientSummary',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/clients-details');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch clients');
    }
  }
);
// Fetch Clients Summary
export const fetchVendorSummary = createAsyncThunk(
  'vendor/fetchVendorSummary',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/vendor-details');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch vendor');
    }
  }
);
